import { BorderLeft } from "@material-ui/icons";
import Select from "react-select";

function CSelect({
  children,
  className,
  placeholder = "",
  width,
  height = "32px",
  isClearable = false,
  isSearchable = false,
  isMulti = false,
  isDisabled = false,
  isLoading = false,
  hideSelectedOptions = false,
  options = [],
  borderRight,
  borderLeft,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  defaultValue,
  style,
  ...rest
}) {
  const customStyles = {
    control: (styles) => {
      return {
        ...styles,

        width: width,

        minHeight: height,
        borderRadius: "0.5rem",

        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        border: "1px solid rgba(229, 231, 235)",
        ":hover": {
          border: "1px solid #b3b3b3",
        },
        borderRight: borderRight,
        boderLeft: borderLeft,

        ":focus-within": {
          border: "2px solid rgba(64, 148, 247, 0.5)",
          boxShadow:
            "var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
        },
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "0 14px",
      fontSize: "12.5px",
    }),
    input: (provided, state) => ({
      ...provided,

      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: height,
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#999",
      };
    },
    option: (styles) => {
      return {
        ...styles,
      };
    },
    menu : (styles) => {
      return {
        ...styles,
        width
      }
    }
  };

  return (
    <div
      style={style}
      className={`${className} text-body focus-within:z-40 border-0`}
    >
      <Select
        className="basic-single"
        classNamePrefix="select"
        value={defaultValue}
        placeholder={placeholder}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        isLoading={isLoading}
        hideSelectedOptions={hideSelectedOptions}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        options={options}
        styles={customStyles}
        {...rest}
      />
    </div>
  );
}

export default CSelect;
